import { Link, useNavigate, useParams } from "react-router-dom";
import { useTitle } from "../../helper/Title";
import HeaderComp from "../Header";
import { StarRating } from "../../helper/StarRating";
import { useEffect, useRef } from "react";
import blogService from "../../services/blog.service";
import { useState } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Textarea from "react-validation/build/textarea";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import userService from "../../services/user.service";
import { formatDate } from "../../helper/dateformater";
import FooterComp from "../Footer";
const required = (value) => {
  if (!value) {
    return (
      <div className="text-danger px-3" role="alert">
        This field is required!
      </div>
    );
  }
};

const email = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="text-danger px-3" role="alert">
        This is not a valid email.
      </div>
    );
  }
};
const ArticleComp = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState({});
  const [comments, setComments] = useState([]);
  const [success, setSuccess] = useState({});
  // const [commentfield, setReplies] = useState({});
  const [submited, setSubmited] = useState(false);
  const form = useRef();
  const comment = useRef();
  const checkBtn = useRef();
  const [field, setField] = useState({
    email: "",
    name: "",
    rate: 0,
    comment: "",
    reply_id: null,
  });

  const onChangeField = (e, f) => {
    const name = e.target.value;
    const c = { ...field };
    c[f] = name;
    setField(c);
  };

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [relatedpost, setRelatedPost] = useState([]);
  const div_ref = useRef();
  const handlecomment = (e) => {
    var post_id = article.id;
    e.preventDefault();
    setLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0 && user.email) {
      // console.log(field);
      blogService
        .sendcomment(field.comment, post_id, field.rate, field.reply_id)
        .then((res) => {
          // console.log(res);

          var temp = [...comments];
          var last = comments.length + 1;
          var post = 0;

          temp.push({
            id: last,
            like: 0,
            dislike: 0,
            time: new Date(),
            post,
            content: field.comment,
            user: user.first_name + " " + user.last_name,
            reply_id: field.reply_id,
          });
          setComments(temp);
          setLoading(false);
          setSubmited("ok");
          if (!field.reply_id) {
            setTimeout(() => {
              const messages = div_ref.current;
              messages.lastChild.scrollIntoView({ behavior: "smooth" });
            }, 2000);
          }
        })
        .catch(() => {
          setSubmited("nok");
        });
      setLoading(false);
    } else {
      setLoading(false);
      // setSubmited("nok");
    }
  };
  const handleLikecomment = (comment_id, isliked) => {
    if (isliked) {
      blogService.removelikecomment(comment_id).then((r) => {
        var index = comments.findIndex((c) => c.id === comment_id);
        var temp = [...comments];
        temp[index].like = temp[index].like - 1;
        temp[index].user_like = false;
        setComments(temp);
      });
    } else {
      blogService.likecomment(comment_id).then((r) => {
        if (r.data.message == "Already liked") {
          return;
        }
        var index = comments.findIndex((c) => c.id === comment_id);
        var temp = [...comments];
        temp[index].like = temp[index].like + 1;
        temp[index].user_like = true;
        setComments(temp);
      });
    }
  };
  const handleDislikecomment = (comment_id, isliked) => {
    if (isliked) {
      blogService.removedislikecomment(comment_id).then((r) => {
        var index = comments.findIndex((c) => c.id === comment_id);
        var temp = [...comments];
        temp[index].dislike = temp[index].dislike - 1;
        temp[index].user_dislike = false;
        setComments(temp);
      });
    } else {
      blogService.dislikecomment(comment_id).then((r) => {
        if (r.data.message == "Already disliked") {
          return;
        }
        var index = comments.findIndex((c) => c.id === comment_id);
        var temp = [...comments];
        temp[index].dislike = temp[index].dislike + 1;
        temp[index].user_dislike = true;
        setComments(temp);
      });
    }
  };
  const getcommentreplies = (post_id) => {
    blogService.getcommentreplies(post_id).then((r) => {
      var index = comments.findIndex((c) => c.id === post_id);
      var temp = [...comments];
      temp[index].replies = r.data.comments;
      setComments(temp);
    });
  };
  useEffect(() => {
    if (localStorage.getItem("user")) {
      userService.getProfile().then(
        (response) => {
          // console.log(response);
          setUser(response.data.user);
          var tempfield = { ...field };
          tempfield.name = response.data.user.first_name;
          tempfield.email = response.data.user.email;
          setField(tempfield);
        },
        (error) => {
          console.log(error);
        }
      );
    }
    blogService
      .getPostByslug(slug)
      .then((article) => {
        // console.log(article);
        if (article.primary_tag?.slug) {
          blogService
            .getsimilarpost(article.primary_tag.slug, article.id)
            .then((res) => {
              setRelatedPost(res);
            });
        }

        var post_id = article.id;
        blogService.addpostview(post_id);
        setArticle(article);
        document
          .getElementById("article-content")
          .insertAdjacentHTML("beforeend", article.html);
        blogService
          .getpostcomment(post_id)
          .then(function (res) {
            // console.log(res);
            setComments(res);
          })
          .catch((err) => {
            // console.log(err);
          });
      })
      .catch((err) => {
        // console.log(err);
        navigate("NotFoundComp");
      });
  }, []);
  useTitle(
    article.title ? article.title + " | Healthy Pregnancy" : "Healthy Pregnancy"
  );
  function refreshArticle(slug) {
    window.location = slug;
  }

  return (
    <>
      <HeaderComp />
      <div id="blog" className="contents">
        <div className="header-svg">
          <svg
            className="blog-cir-1"
            width="285"
            height="200"
            viewBox="0 0 335 258"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="159.5" cy="82.5" r="175.5" fill="#A460A9" />
          </svg>
          <svg
            className="blog-cir-2"
            width="1440"
            height="140"
            viewBox="0 0 1440 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="-23"
              y="-262"
              width="1487"
              height="461"
              rx="230.5"
              fill="#A460A9"
            />
          </svg>
          <svg
            className="blog-cir-3"
            width="285"
            height="200"
            viewBox="0 0 335 258"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="201" cy="82.5" r="175.5" fill="#A460A9" />
          </svg>

          <Link
            to="/"
            className="logo-hp"
            style={{ position: "relative", zIndex: "50" }}
          >
            <svg
              className="position-absolute top-0 mx-4"
              width="200"
              height="200"
              viewBox="0 0 240 240"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_252_428)">
                <path
                  d="M106.036 70.2012L105.634 72.8703C105.054 77.9115 99.5707 82.3736 97.3571 83.9836C94.7576 80.808 95.3657 78.1537 95.5849 77.4768C96.8365 73.9634 102.363 71.4232 106.036 70.2012Z"
                  fill="white"
                />
                <path
                  d="M142.334 109.696C141.466 106.668 139.908 103.907 137.786 101.579C135.222 98.7645 132.231 96.4073 129.339 94.1277C128.916 93.7952 128.495 93.4627 128.082 93.1338C127.743 92.8628 125.965 91.4023 124.093 89.2613L122.588 87.0751C122.588 87.0751 123.897 89.0332 126.829 88.9991L126.837 88.9969C126.845 88.9969 126.852 88.9969 126.86 88.9976C127.82 88.9828 128.952 88.754 130.269 88.1741C131.503 87.4068 132.07 86.2789 132.403 85.3969C132.522 85.0828 132.615 84.9014 132.677 84.7992C133.858 84.64 134.663 84.1534 135.069 83.3491C135.278 82.9351 135.339 82.5093 135.308 82.1138C135.776 81.6154 136.106 80.8844 136.021 79.898L136.014 79.8128L135.997 79.7284C135.979 79.6402 135.972 79.5499 135.972 79.4588L136.085 79.5573C136.225 79.6632 136.359 79.7691 136.496 79.8758C136.857 80.192 137.277 80.5682 137.739 80.9977C145.474 88.1911 149.595 98.2935 149.437 108.697C149.343 107.762 149.207 106.821 149.038 105.894C148.794 104.628 148.492 103.385 148.11 102.18C147.923 101.577 147.718 100.986 147.493 100.408C147.274 99.8303 147.039 99.2652 146.787 98.7201C146.297 97.6255 145.73 96.5991 145.162 95.6666C144.601 94.7261 143.999 93.8789 143.414 93.122C142.834 92.3614 142.248 91.706 141.704 91.1535C141.165 90.5966 140.653 90.1552 140.226 89.8012C139.799 89.4494 139.438 89.1991 139.197 89.0332C138.951 88.8702 138.82 88.7843 138.82 88.7843C138.82 88.7843 138.928 88.8976 139.131 89.1109C139.338 89.3227 139.62 89.6441 139.978 90.0552C140.33 90.4706 140.738 90.9883 141.184 91.5949C141.625 92.2044 142.089 92.9146 142.569 93.7026C143.042 94.4943 143.52 95.3704 143.995 96.3132C144.47 97.2604 144.908 98.2691 145.326 99.337C145.742 100.402 146.115 101.525 146.445 102.679C146.771 103.831 147.054 105.024 147.273 106.216C148.359 112.123 146.65 118.544 148.844 124.225C149.537 126.018 150.727 127.73 152.489 128.499C152.575 128.538 152.664 128.573 152.753 128.604C154.481 129.22 156.672 128.713 157.559 127.114C157.599 128.883 156.018 130.414 154.273 130.703C152.526 130.991 150.737 130.249 149.378 129.118C143.293 124.057 144.306 116.575 142.334 109.696Z"
                  fill="white"
                />
                <path
                  d="M87.9839 103.161V102.068C88.2201 98.1862 88.8993 94.7669 90.2783 92.4688C91.9024 89.8168 94.0834 87.5439 96.9325 85.9234C96.9325 85.9234 106.016 80.172 106.836 73.046L107.359 69.5764C107.366 69.5253 107.407 69.4853 107.458 69.4786C108.795 69.2972 125.391 66.8806 130.291 57.3388C128.239 59.8953 122.284 65.4076 107.698 68.11C107.698 68.11 94.1264 71.4597 93.7924 78.6701C93.7924 78.6701 92.5882 71.5686 97.5272 67.1028C98.6262 66.4444 102.126 43.7837 120.431 40.5051C122.653 39.8912 124.966 39.5942 127.348 39.7001C136.698 40.1134 143.865 48.996 143.679 58.1172C142.305 56.9581 140.791 56.3716 140.019 56.1257C141.861 56.7345 143.596 58.3334 144.416 60.0257C145.696 62.6696 144.757 66.1608 144.158 68.8661C144.053 69.6097 144.029 70.3562 144.273 71.0864C144.581 72.0114 145.179 72.9557 146.338 73.2364C144.413 72.9438 143.639 70.9665 143.484 69.2483C143.408 68.4003 143.445 67.5501 143.468 66.6992C143.576 65.6846 143.488 64.787 143.327 64.0427C143.322 64.016 143.319 63.9879 143.314 63.9612C143.311 63.9508 143.305 63.9323 143.3 63.9197C143.037 62.7785 142.614 62.0349 142.505 61.8727C142.336 61.5476 142.142 61.2269 141.909 60.927C141.507 60.4041 141.001 59.9405 140.436 59.5732C139.867 59.2081 139.237 58.9585 138.607 58.7904C137.975 58.6134 137.319 58.566 136.759 58.5067C136.182 58.4371 135.63 58.3549 135.117 58.2349C134.603 58.1142 134.127 57.9646 133.704 57.7854C133.284 57.6025 132.906 57.4092 132.595 57.1981C132.435 57.0974 132.3 56.9841 132.165 56.89C132.041 56.7849 131.923 56.69 131.821 56.599C131.723 56.5049 131.634 56.4205 131.557 56.3472C131.48 56.2724 131.422 56.2013 131.371 56.1479C131.27 56.0376 131.217 55.9798 131.217 55.9798C131.217 55.9798 131.169 56.0768 131.062 56.2546C131.137 56.3738 131.242 56.5234 131.384 56.7034C131.471 56.8115 131.576 56.9233 131.693 57.0567C131.813 57.1744 131.941 57.3062 132.092 57.4314C132.388 57.6928 132.758 57.9476 133.187 58.1816C133.616 58.4156 134.105 58.626 134.639 58.7867C135.172 58.9511 135.745 59.0851 136.341 59.1748C136.49 59.1977 136.64 59.2192 136.791 59.2414C136.938 59.2651 137.084 59.2881 137.231 59.311C137.526 59.3643 137.795 59.4251 138.084 59.5058C138.633 59.6613 139.169 59.8813 139.648 60.1901C139.679 60.2094 139.699 60.2397 139.702 60.276C139.735 60.5819 139.878 62.1408 139.665 64.3804C139.659 64.4463 139.653 64.5122 139.646 64.5781C139.597 65.0188 139.44 66.1489 139.031 67.4213C138.76 68.2626 138.36 69.0528 137.904 69.8104C137.832 69.9311 137.759 70.0614 137.688 70.2014C137.068 71.4278 136.603 73.3756 137.592 75.9877C137.601 76.0099 137.603 76.0343 137.598 76.0573C137.455 76.672 136.87 77.14 136.184 77.0874L135.043 77.0001C135.003 76.9971 134.965 77.0134 134.94 77.0467C134.746 77.3193 133.884 78.6264 134.163 80.0306C134.265 81.2051 133.294 81.397 133.294 81.397V81.5762C133.275 81.9776 133.102 82.9507 131.912 83.2996C131.241 83.3544 130.828 84.3541 130.639 84.854C130.139 86.1775 129.416 87.0062 127.928 87.3513C125.022 88.0267 121.311 85.7087 118.49 83.4084C118.398 83.3329 118.264 83.4291 118.307 83.541C120.526 89.1776 126.076 93.7582 126.794 94.3336C130.096 96.9553 133.482 99.4956 136.324 102.615C143.242 110.207 140.932 116.682 133.202 120.291C133.119 120.331 133.107 120.442 133.182 120.492C134.307 121.249 140.723 125.776 145.888 133.897C146.751 134.997 147.533 136.159 148.213 137.384C148.865 138.556 149.39 139.724 149.808 140.892C149.876 141.038 153.527 148.98 152.554 158.369C152.524 158.662 152.489 158.958 152.449 159.254C152.444 159.288 152.426 159.311 152.402 159.329L152.35 159.666C152.371 159.691 152.385 159.721 152.38 159.755L152.305 160.229L152.064 161.48C151.973 161.896 151.87 162.313 151.758 162.732L151.556 162.725C151.493 162.722 151.432 162.715 151.37 162.712C151.245 162.704 151.119 162.695 150.994 162.68C150.922 162.672 150.851 162.66 150.779 162.65C150.488 162.607 150.202 162.548 149.92 162.471C149.76 162.427 149.602 162.376 149.446 162.321C149.412 162.31 149.377 162.301 149.343 162.288C148.965 162.15 148.6 161.98 148.25 161.782C148.19 161.748 148.132 161.709 148.073 161.673C147.962 161.605 147.852 161.539 147.745 161.467C147.607 161.371 147.469 161.273 147.338 161.168C147.739 161.203 148.338 161.296 149.218 161.508C149.396 161.551 149.578 161.572 149.761 161.572C149.792 161.572 149.865 161.571 149.865 161.571C150.614 161.571 151.295 161.29 151.832 160.76C152.16 160.438 152.29 159.979 152.178 159.533C152.067 159.089 151.738 158.744 151.296 158.614C150.746 158.45 150.295 158.279 150.025 158.128C149.381 157.77 148.866 157.528 148.356 157.345C148.055 157.239 147.762 157.141 147.485 157.056C146.753 156.834 145.988 156.72 145.21 156.72C144.781 156.72 144.346 156.755 143.919 156.825C142.449 157.062 139.714 157.459 137.927 157.459C137.595 157.459 137.313 157.446 137.087 157.426C137.087 157.426 136.959 157.42 136.958 157.411C136.926 157.414 136.894 157.414 136.862 157.414L136.26 157.381C136.126 157.357 135.994 157.316 135.862 157.269C135.479 157.131 135.106 156.91 134.752 156.666C134.746 156.662 134.74 156.658 134.734 156.654C134.669 156.609 134.605 156.563 134.541 156.518C134.526 156.506 134.509 156.495 134.494 156.483C134.438 156.443 134.383 156.403 134.329 156.362C134.26 156.312 134.192 156.259 134.124 156.209C133.971 156.094 133.818 155.977 133.664 155.862C132.99 155.355 132.317 154.846 131.643 154.337L130.889 153.768L130.718 153.638L130.63 153.711L130.693 153.62C130.552 153.523 116.593 143.875 109.265 139.374L109.231 139.355L109.203 139.341L105.589 137.293L105.117 137.027C105.537 133.232 104.427 118.885 104.053 114.311C104.053 114.163 104.055 114.015 104.056 113.866L103.322 114.818C103.663 119.038 104.89 134.927 104.279 137.401C104.289 137.429 104.308 137.452 104.334 137.466L108.838 140.018C108.846 140.022 108.855 140.026 108.862 140.03C116.258 144.571 130.255 154.253 130.255 154.253C131.392 155.111 132.528 155.97 133.662 156.823C134.412 157.388 135.198 157.968 136.121 158.137C136.411 158.19 136.701 158.197 136.996 158.182C138.665 158.385 142.206 157.88 144.042 157.584C145.118 157.411 146.22 157.475 147.261 157.793C147.556 157.882 147.839 157.978 148.096 158.07C148.637 158.263 149.15 158.521 149.652 158.8C150.051 159.022 150.628 159.217 151.078 159.351C151.456 159.463 151.573 159.937 151.292 160.213C150.983 160.517 150.511 160.809 149.839 160.801C149.698 160.808 149.552 160.797 149.398 160.76C145.375 159.79 146.007 160.986 146.007 160.986C147.411 162.487 149.418 163.405 151.47 163.491C151.507 163.492 151.541 163.51 151.562 163.542C151.782 163.888 152.987 165.96 150.642 166.376C150.568 166.39 150.522 166.466 150.553 166.534C150.787 167.072 151.485 169.039 149.192 169.108C149.117 169.11 149.061 169.179 149.079 169.251C149.193 169.694 149.43 171.05 148.256 171.596C147.416 171.986 147.995 173.066 146.869 173.348C145.585 173.67 143.992 173.836 142.797 173.149C142.251 172.916 141.723 172.615 141.245 172.291C138.515 170.437 136.266 168.008 133.704 165.946C130.955 163.732 127.895 162.587 124.814 160.962C117.393 157.043 109.971 153.677 103.068 148.852C98.8995 145.943 94.3315 143.093 92.7496 137.959C92.1623 136.053 91.6387 134.118 91.141 132.174C91.1062 132.018 87.4581 115.683 87.9254 103.256C87.9269 103.213 87.9513 103.18 87.9839 103.161Z"
                  fill="white"
                />
                <path
                  d="M137.006 158.178L136.993 158.182L136.995 158.178H137.006Z"
                  fill="white"
                />
                <path
                  d="M96.6891 198.558C91.702 191.838 87.2947 181.589 91.0503 168.351C91.248 167.61 91.4806 166.863 91.7523 166.11C92.624 163.693 93.8845 161.213 95.6057 158.682C96.0211 158.07 96.487 157.496 96.9728 156.939C97.8733 155.904 99.7004 153.127 99.042 148.181C99.9218 148.835 100.826 149.461 101.723 150.081C102.026 150.291 102.327 150.501 102.626 150.71C107.9 154.394 113.58 157.29 119.072 160.09C120.835 160.99 122.66 161.92 124.455 162.868C125.326 163.328 126.2 163.752 127.045 164.162C129.237 165.225 131.307 166.23 133.223 167.772C134.208 168.565 135.17 169.435 136.101 170.277C137.579 171.613 139.107 172.996 140.813 174.154C142.19 175.089 143.466 175.563 144.606 175.563C144.662 175.563 144.717 175.558 144.774 175.556C144.826 175.557 144.88 175.563 144.933 175.563C145.136 175.563 145.332 175.544 145.525 175.513C142.979 178.159 139.644 180.623 135.304 182.746C135.304 182.746 130.866 184.668 132.403 189.281L138.208 199.823C176.828 191.472 205.766 157.118 205.766 116C205.766 68.6332 167.367 30.2343 119.999 30.2343C72.6325 30.2343 34.2342 68.6332 34.2342 116C34.2342 155.288 60.6504 188.403 96.6891 198.558ZM119.999 16.0001C175.228 16.0001 220 60.7719 220 116C220 171.229 175.228 216 119.999 216C64.7711 216 20.0001 171.229 20.0001 116C20.0001 60.7719 64.7711 16.0001 119.999 16.0001Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_252_428"
                  x="0"
                  y="0.00012207"
                  width="240"
                  height="240"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="10" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_252_428"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_252_428"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </Link>
          <Link to="/babycheck" className="blog-cir-babycheck">
            Baby check
          </Link>
        </div>
        {/* start popular section */}
        <div className="article-container">
          <div className="blog-tab-haeds d-flex flex-row align-items-end">
            <div className="article-toggler-slide">{article.title}</div>
          </div>
          <div className="blog-tab-contents">
            {article?.feature_image ? (
              <img
                srcSet={`${article.feature_image} 300w,
              ${article.feature_image} 600w,
              ${article.feature_image} 1000w,
              ${article.feature_image} 2000w`}
                sizes="(min-width: 1400px) 1400px, 92vw"
                src={article.feature_image}
                alt={article.title}
                className="w-100"
                style={{
                  borderRadius: "60px",
                  border: "10px solid var(--blue-2)",
                }}
              />
            ) : (
              <div
                style={{
                  height: "608px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "60px",
                  backgroundColor: "white",
                  border: "30px solid var(--blue-2)",
                }}
                className="w-100 article_img_load"
              >
                <span className="spinner-border "></span>
              </div>
            )}
            <div className="blog-info d-flex">
              <div className="blog-info-left-container">
                <div className="blog-info-left-circle">
                  {article?.authors && article?.authors[0]?.profile_image ? (
                    <img
                      src={article.authors[0].profile_image}
                      alt="author image"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="blog-info-left-author">
                  {article.authors && article.authors[0].name}
                </div>
                <div className="blog-info-left-date">
                  {formatDate(new Date(article.published_at), "/")}
                </div>
              </div>
              <div className="blog-info-right-container">
                <StarRating number={parseFloat(article?.rate_value)} />
                <div className="blog-view d-flex justify-content-around">
                  <div>
                    <svg
                      width="25"
                      height="16"
                      viewBox="0 0 25 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.1562 5.25577C14.9176 5.25577 17.1562 7.49437 17.1562 10.2557C17.1562 13.0172 14.9176 15.2558 12.1562 15.2558C9.39478 15.2558 7.15621 13.0172 7.15621 10.2557C7.15621 7.49437 9.39478 5.25577 12.1562 5.25577ZM12.1562 7.13075C10.4304 7.13075 9.03121 8.52987 9.03121 10.2557C9.03121 11.9816 10.4304 13.3807 12.1562 13.3807C13.8821 13.3807 15.2812 11.9816 15.2812 10.2557C15.2812 8.52987 13.8821 7.13075 12.1562 7.13075ZM12.1562 0.875C17.9231 0.875 22.9014 4.81251 24.2826 10.3305C24.4084 10.8327 24.1031 11.3419 23.6009 11.4676C23.0985 11.5933 22.5895 11.2881 22.4637 10.7858C21.2901 6.09745 17.0579 2.75 12.1562 2.75C7.25238 2.75 3.01883 6.10033 1.84728 10.7915C1.72183 11.2937 1.21291 11.5992 0.710568 11.4739C0.208231 11.3484 -0.0972942 10.8395 0.0281558 10.3371C1.40702 4.8159 6.38682 0.875 12.1562 0.875Z"
                        fill="white"
                      />
                    </svg>
                    <span className="mx-1">{article.views}</span>
                  </div>
                  <div className="text-white">
                    <span className="mx-1">{article?.rate_value}</span>
                    Ratings
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* end popular section */}
        {/* start aricle content */}
        <div id="article-content" className="article-content-container"></div>
        {/* end aricle content */}
        {/* start Similar content */}
        {relatedpost.length > 0 && (
          <div className="article-similar">
            <div className="blog-recently-reg-1">Similar topics</div>
            <div className="blog-recently-grid justify-content-start">
              {relatedpost?.map((p, i) => {
                var rating = (p.like / p.views) * 5;

                return (
                  <div className="blog-tab-item grid-item" key={i}>
                    <div className="blog-tab-item-img">
                      <img
                        src={p.feature_image}
                        alt=""
                        onClick={() => {
                          refreshArticle(p.slug);
                        }}
                      />
                    </div>

                    <div
                      className="blog-tab-item-title"
                      onClick={() => {
                        refreshArticle(p.slug);
                      }}
                    >
                      {p.title}
                    </div>

                    <div className="blog-tab-item-desc">{p.excerpt}</div>
                    <div className="d-flex justify-content-center mb-2">
                      <StarRating number={rating} />
                    </div>
                    <div className="d-flex flex-row">
                      <div className="blog-tab-item-footer-desc me-2">
                        Healthy pregnancy team
                      </div>
                      <div className="blog-tab-item-footer-time">
                        {formatDate(new Date(p.published_at), "/")}
                      </div>
                    </div>
                    <div className="d-flex flex-row justify-content-center mt-3">
                      <div>
                        <svg
                          width="26"
                          height="16"
                          viewBox="0 0 26 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13 5.25577C15.7614 5.25577 18 7.49437 18 10.2557C18 13.0172 15.7614 15.2558 13 15.2558C10.2385 15.2558 7.99996 13.0172 7.99996 10.2557C7.99996 7.49437 10.2385 5.25577 13 5.25577ZM13 7.13075C11.2741 7.13075 9.87496 8.52987 9.87496 10.2557C9.87496 11.9816 11.2741 13.3807 13 13.3807C14.7259 13.3807 16.125 11.9816 16.125 10.2557C16.125 8.52987 14.7259 7.13075 13 7.13075ZM13 0.875C18.7669 0.875 23.7451 4.81251 25.1264 10.3305C25.2521 10.8327 24.9469 11.3419 24.4446 11.4676C23.9422 11.5933 23.4332 11.2881 23.3075 10.7858C22.1339 6.09745 17.9016 2.75 13 2.75C8.09613 2.75 3.86258 6.10033 2.69103 10.7915C2.56558 11.2937 2.05666 11.5992 1.55432 11.4739C1.05198 11.3484 0.746456 10.8395 0.871906 10.3371C2.25077 4.8159 7.23057 0.875 13 0.875Z"
                            fill="#A460A9"
                          />
                        </svg>
                      </div>
                      <div className="mx-2 color-purple">{p.views}</div>
                    </div>
                    <div className="blog-tab-time">
                      <svg
                        width="66"
                        height="66"
                        viewBox="0 0 66 66"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="32.8906"
                          y="-6"
                          width="55"
                          height="55"
                          rx="15"
                          transform="rotate(45 32.8906 -6)"
                          fill="#A460A9"
                        />
                      </svg>
                      <div className="position-absolute">
                        <span>{p.reading_time}</span>
                        Min
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {/* end Similar content */}
        {/* start article reviews section*/}
        <div className="article-reviews" ref={comment}>
          <div>
            <Form onSubmit={handlecomment} className="w-50" ref={form}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">
                  Name
                </label>

                <Input
                  validations={[required]}
                  placeholder="Please enter your name"
                  name="name"
                  value={field.name}
                  // disabled={user ? true : false}
                  onChange={(e) => onChangeField(e, "name")}
                  className="form-input w-100"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email
                </label>

                <Input
                  validations={[required, email]}
                  placeholder="Please enter your Email or username"
                  name="email"
                  // disabled={user ? true : false}
                  value={field.email}
                  onChange={(e) => onChangeField(e, "email")}
                  className="form-input w-100"
                />
              </div>
              <div className="form-group">
                <label htmlFor="rate" className="form-label">
                  Tap to rate
                </label>
                <StarRating
                  number={0}
                  clickable={true}
                  callback={(e) => {
                    const c = { ...field };
                    c["rate"] = e;
                    setField(c);
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="comment" className="form-label">
                  Comment
                </label>
                <Textarea
                  validations={[required]}
                  placeholder="Enter your comment here"
                  name="comment"
                  value={field.comment}
                  onChange={(e) => onChangeField(e, "comment")}
                  className="form-input w-100"
                  style={{ height: "200px", borderRadius: "60px" }}
                ></Textarea>
              </div>
              <div className="form-group align-items-end">
                {!user?.email && (
                  <div className="text-danger">
                    You are not authorized to send comment for this article
                  </div>
                )}
                <button
                  className={`login-form-button ${
                    user?.email || !submited ? "" : "disabled"
                  }`}
                  disabled={loading || !user?.email || submited}
                  style={{
                    width: "260px",
                    backgroundColor: submited
                      ? submited == "ok"
                        ? "#288D05"
                        : "#CF0000"
                      : "#05668D",
                  }}
                >
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  <span>
                    {submited
                      ? submited == "ok"
                        ? "Submited"
                        : "Not submited"
                      : "Submit"}
                  </span>
                </button>
              </div>
              <CheckButton
                className="login-form-button"
                style={{ display: "none" }}
                ref={checkBtn}
              />
            </Form>
            <div className="article-reviews-answers-list">
              <ul className="answer-list p-0" ref={div_ref}>
                {comments &&
                  comments?.map((c, i) => {
                    // console.log(comments);
                    var regex = /(<([^>]+)>)/gi,
                      // comment_text = c?.html?.replace(regex, "");
                      comment_text = c?.content;
                    var replies = comments.filter((f) => f.reply_id == c.id);
                    replies = replies.length ? replies : null;
                    if (!c.reply_id) {
                      var style = {
                        text:
                          i % 2 === 0
                            ? {
                                fontSize: "var(--font-size-m)",
                                color: "var(--purple)",
                              }
                            : {
                                fontSize: "var(--font-size-m)",
                                color: "var(--buster)",
                              },
                        text_comment:
                          i % 2 === 0
                            ? {
                                fontSize: "var(--font-size-m)",
                                color: "black",
                              }
                            : {
                                fontSize: "var(--font-size-m)",
                                color: "white",
                              },
                        background:
                          i % 2 === 0
                            ? {
                                backgroundColor: "#d9d9d9",
                              }
                            : {
                                backgroundColor: "var(--purple)",
                              },
                        svg:
                          i % 2 === 0
                            ? {
                                fill: "#05668D",
                              }
                            : {
                                fill: "var(--buster)",
                              },
                      };
                      return (
                        <li
                          className={`answer-parent ${
                            replies ? "haschilds" : ""
                          }`}
                          key={i}
                        >
                          <div>
                            <div
                              className="answer-content-parent position-relative"
                              style={style.background}
                            >
                              <div className="d-flex justify-content-between">
                                <div
                                  className="review-answer-name"
                                  style={style.text}
                                >
                                  {/* {c.member.name}: */}
                                  {c.user}:
                                </div>
                                <div
                                  className="review-answer-date"
                                  style={style.text}
                                >
                                  {formatDate(new Date(c.time), "/")}
                                </div>
                              </div>
                              <div
                                className="review-answer-text px-3 pt-3 mb-4"
                                style={style.text_comment}
                              >
                                {comment_text}
                              </div>
                              <div
                                style={{
                                  cursor: "pointer",
                                  textAlign: "right",
                                }}
                                onClick={() => {
                                  setField({ ...field, reply_id: c.id });

                                  comment.current.scrollIntoView({
                                    behavior: "smooth",
                                  });
                                }}
                              >
                                <svg
                                  width="22"
                                  height="20"
                                  viewBox="0 0 42 40"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.93734 31.5C3.1979 31.5 0.166504 28.4685 0.166504 24.7292V7.02083C0.166504 3.2814 3.1979 0.25 6.93734 0.25H35.0623C38.8017 0.25 41.8332 3.2814 41.8332 7.02083V24.7292C41.8332 28.4685 38.8017 31.5 35.0623 31.5H23.1092L12.6638 39.314C11.512 40.1754 9.88005 39.94 9.01861 38.7883C8.68184 38.3379 8.49984 37.7908 8.49984 37.229L8.49819 31.5H6.93734ZM22.0696 28.375H35.0623C37.0759 28.375 38.7082 26.7427 38.7082 24.7292V7.02083C38.7082 5.00729 37.0759 3.375 35.0623 3.375H6.93734C4.9238 3.375 3.2915 5.00729 3.2915 7.02083V24.7292C3.2915 26.7427 4.9238 28.375 6.93734 28.375H11.6223L11.6228 29.9371L11.6245 36.1888L22.0696 28.375Z"
                                    fill={style.svg.fill}
                                  />
                                </svg>
                              </div>
                            </div>
                            <div className="answer-rating">
                              <div
                                className="answer-rating-up mx-4"
                                onClick={() => {
                                  handleLikecomment(c.id, c.user_like);
                                }}
                              >
                                <svg
                                  width="46"
                                  height="54"
                                  viewBox="0 0 46 54"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M34.249 11.0065C34.249 4.90162 31.3987 0.509766 26.733 0.509766C24.1675 0.509766 23.2872 2.01317 22.3675 5.50869C22.1797 6.23082 22.0875 6.58242 21.99 6.92892C21.7375 7.82577 21.298 9.35264 20.6725 11.5064C20.6558 11.5641 20.631 11.6185 20.599 11.6687L13.432 22.8829C11.7369 25.5352 9.23572 27.574 6.29602 28.6995L5.11282 29.1525C1.996 30.346 0.186424 33.6052 0.821749 36.8817L1.83297 42.097C2.43655 45.2097 4.7957 47.687 7.87525 48.4417L26.9445 53.1155C33.2725 54.6665 39.6685 50.8292 41.2783 44.516L44.8155 30.643C45.9243 26.2947 43.298 21.8711 38.9497 20.7624C38.2937 20.5952 37.6195 20.5105 36.9422 20.5105H32.384C33.6242 16.4283 34.249 13.2789 34.249 11.0065ZM4.50317 36.168C4.2144 34.6787 5.03692 33.197 6.45367 32.6547L7.63687 32.2015C11.3259 30.7892 14.4646 28.2307 16.5918 24.9022L23.7587 13.6881C23.9837 13.3359 24.1572 12.9533 24.2737 12.5518C24.902 10.3893 25.3437 8.85437 25.5997 7.94464C25.7075 7.56152 25.8097 7.17289 25.994 6.46297C26.4687 4.65869 26.7022 4.25977 26.733 4.25977C28.9022 4.25977 30.499 6.71992 30.499 11.0065C30.499 13.2177 29.6845 16.8451 28.0395 21.7941C27.636 23.008 28.5395 24.2605 29.8187 24.2605H36.9422C37.307 24.2605 37.67 24.306 38.0232 24.3962C40.3647 24.9932 41.7787 27.3752 41.1817 29.7165L37.6445 43.5892C36.543 47.909 32.167 50.5345 27.8372 49.4732L8.76795 44.7995C7.10972 44.393 5.83942 43.0592 5.51442 41.383L4.50317 36.168Z"
                                    fill="#05668D"
                                  />
                                </svg>
                                <span className="answer-rate-up-number">
                                  {c.like}
                                </span>
                              </div>
                              <div
                                className="answer-rating-down"
                                onClick={() => {
                                  handleDislikecomment(c.id, c.user_dislike);
                                }}
                              >
                                <svg
                                  width="46"
                                  height="54"
                                  viewBox="0 0 46 54"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M34.249 42.963C34.249 49.0678 31.3987 53.4595 26.733 53.4595C24.2957 53.4595 23.3795 52.1027 22.5052 48.9702L21.99 47.0405C21.7375 46.1435 21.298 44.6167 20.6725 42.463C20.6558 42.4053 20.631 42.3507 20.599 42.3008L13.432 31.0865C11.7369 28.434 9.23572 26.3953 6.29602 25.2697L5.11282 24.8167C1.996 23.6235 0.186424 20.364 0.821749 17.0876L1.83297 11.8724C2.43655 8.7597 4.7957 6.28245 7.87525 5.52765L26.9445 0.853825C33.2725 -0.697155 39.6685 3.14017 41.2783 9.4535L44.8155 23.3265C45.9243 27.6745 43.298 32.0982 38.9497 33.207C38.2937 33.3742 37.6195 33.4588 36.9422 33.4588H32.384C33.6242 37.541 34.249 40.6905 34.249 42.963ZM4.50317 17.8015C4.2144 19.2908 5.03692 20.7723 6.45367 21.3148L7.63687 21.7677C11.3259 23.1803 14.4646 25.7385 16.5918 29.067L23.7587 40.2812C23.9837 40.6335 24.1572 41.016 24.2737 41.4175L25.6535 46.2183L26.1827 48.1965C26.5312 49.4165 26.7067 49.7095 26.733 49.7095C28.9022 49.7095 30.499 47.2495 30.499 42.963C30.499 40.7518 29.6845 37.1243 28.0395 32.1753C27.636 30.9615 28.5395 29.7088 29.8187 29.7088H36.9422C37.307 29.7088 37.67 29.6632 38.0232 29.5732C40.3647 28.9762 41.7787 26.5942 41.1817 24.253L37.6445 10.38C36.543 6.06038 32.167 3.43482 27.8372 4.49602L8.76795 9.16985C7.10972 9.57627 5.83942 10.9102 5.51442 12.5863L4.50317 17.8015Z"
                                    fill="#05668D"
                                  />
                                </svg>

                                <span className="answer-rate-down-number">
                                  {c.dislike}
                                </span>
                              </div>
                            </div>
                          </div>
                          {replies && (
                            <ul className="review-answer-child">
                              {replies.map((r, I, arr) => {
                                var reply_style =
                                  i % 2 === 0
                                    ? {
                                        name:
                                          I % 2 !== 0
                                            ? {
                                                fontSize: "var(--font-size-m)",
                                                color: "var(--purple)",
                                              }
                                            : {
                                                fontSize: "var(--font-size-m)",
                                                color: "var(--buster)",
                                              },
                                        text:
                                          I % 2 !== 0
                                            ? {
                                                fontSize: "var(--font-size-m)",
                                                color: "black",
                                              }
                                            : {
                                                fontSize: "var(--font-size-m)",
                                                color: "var(--white)",
                                              },
                                        background:
                                          I % 2 !== 0
                                            ? {
                                                backgroundColor: "#d9d9d9",
                                              }
                                            : {
                                                backgroundColor:
                                                  "var(--purple)",
                                              },
                                      }
                                    : {
                                        name:
                                          I % 2 === 0
                                            ? {
                                                fontSize: "var(--font-size-m)",
                                                color: "var(--purple)",
                                              }
                                            : {
                                                fontSize: "var(--font-size-m)",
                                                color: "var(--buster)",
                                              },
                                        text:
                                          I % 2 === 0
                                            ? {
                                                fontSize: "var(--font-size-m)",
                                                color: "black",
                                              }
                                            : {
                                                fontSize: "var(--font-size-m)",
                                                color: "var(--white)",
                                              },
                                        background:
                                          I % 2 === 0
                                            ? {
                                                backgroundColor: "#d9d9d9",
                                              }
                                            : {
                                                backgroundColor:
                                                  "var(--purple)",
                                              },
                                      };
                                // if (r.status != "deleted") {
                                // var reply_text = r.html.replace(regex, "");
                                return (
                                  <li
                                    className="answer"
                                    key={I}
                                    style={{ zIndex: 2000 - I }}
                                  >
                                    <div>
                                      <div
                                        className="answer-content"
                                        style={reply_style.background}
                                      >
                                        <div className="d-flex justify-content-between">
                                          <div
                                            className="review-answer-name"
                                            style={reply_style.name}
                                          >
                                            {r.user}:
                                          </div>
                                          <div
                                            className="review-answer-date"
                                            style={reply_style.name}
                                          >
                                            {formatDate(new Date(r.time), "/")}
                                          </div>
                                        </div>
                                        <div
                                          className="review-answer-text px-5 pt-3"
                                          style={reply_style.text}
                                        >
                                          {r.content}
                                        </div>
                                      </div>
                                      <div className="answer-rating">
                                        <div
                                          className="answer-rating-up mx-4"
                                          onClick={() => {
                                            handleLikecomment(
                                              r.id,
                                              r.user_like
                                            );
                                          }}
                                        >
                                          <svg
                                            width="46"
                                            height="54"
                                            viewBox="0 0 46 54"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M34.249 11.0065C34.249 4.90162 31.3987 0.509766 26.733 0.509766C24.1675 0.509766 23.2872 2.01317 22.3675 5.50869C22.1797 6.23082 22.0875 6.58242 21.99 6.92892C21.7375 7.82577 21.298 9.35264 20.6725 11.5064C20.6558 11.5641 20.631 11.6185 20.599 11.6687L13.432 22.8829C11.7369 25.5352 9.23572 27.574 6.29602 28.6995L5.11282 29.1525C1.996 30.346 0.186424 33.6052 0.821749 36.8817L1.83297 42.097C2.43655 45.2097 4.7957 47.687 7.87525 48.4417L26.9445 53.1155C33.2725 54.6665 39.6685 50.8292 41.2783 44.516L44.8155 30.643C45.9243 26.2947 43.298 21.8711 38.9497 20.7624C38.2937 20.5952 37.6195 20.5105 36.9422 20.5105H32.384C33.6242 16.4283 34.249 13.2789 34.249 11.0065ZM4.50317 36.168C4.2144 34.6787 5.03692 33.197 6.45367 32.6547L7.63687 32.2015C11.3259 30.7892 14.4646 28.2307 16.5918 24.9022L23.7587 13.6881C23.9837 13.3359 24.1572 12.9533 24.2737 12.5518C24.902 10.3893 25.3437 8.85437 25.5997 7.94464C25.7075 7.56152 25.8097 7.17289 25.994 6.46297C26.4687 4.65869 26.7022 4.25977 26.733 4.25977C28.9022 4.25977 30.499 6.71992 30.499 11.0065C30.499 13.2177 29.6845 16.8451 28.0395 21.7941C27.636 23.008 28.5395 24.2605 29.8187 24.2605H36.9422C37.307 24.2605 37.67 24.306 38.0232 24.3962C40.3647 24.9932 41.7787 27.3752 41.1817 29.7165L37.6445 43.5892C36.543 47.909 32.167 50.5345 27.8372 49.4732L8.76795 44.7995C7.10972 44.393 5.83942 43.0592 5.51442 41.383L4.50317 36.168Z"
                                              fill="#05668D"
                                            />
                                          </svg>
                                          <span className="answer-rate-up-number">
                                            {r.like}
                                          </span>
                                        </div>
                                        <div
                                          className="answer-rating-down"
                                          onClick={() => {
                                            handleDislikecomment(
                                              r.id,
                                              r.user_dislike
                                            );
                                          }}
                                        >
                                          <svg
                                            width="46"
                                            height="54"
                                            viewBox="0 0 46 54"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M34.249 42.963C34.249 49.0678 31.3987 53.4595 26.733 53.4595C24.2957 53.4595 23.3795 52.1027 22.5052 48.9702L21.99 47.0405C21.7375 46.1435 21.298 44.6167 20.6725 42.463C20.6558 42.4053 20.631 42.3507 20.599 42.3008L13.432 31.0865C11.7369 28.434 9.23572 26.3953 6.29602 25.2697L5.11282 24.8167C1.996 23.6235 0.186424 20.364 0.821749 17.0876L1.83297 11.8724C2.43655 8.7597 4.7957 6.28245 7.87525 5.52765L26.9445 0.853825C33.2725 -0.697155 39.6685 3.14017 41.2783 9.4535L44.8155 23.3265C45.9243 27.6745 43.298 32.0982 38.9497 33.207C38.2937 33.3742 37.6195 33.4588 36.9422 33.4588H32.384C33.6242 37.541 34.249 40.6905 34.249 42.963ZM4.50317 17.8015C4.2144 19.2908 5.03692 20.7723 6.45367 21.3148L7.63687 21.7677C11.3259 23.1803 14.4646 25.7385 16.5918 29.067L23.7587 40.2812C23.9837 40.6335 24.1572 41.016 24.2737 41.4175L25.6535 46.2183L26.1827 48.1965C26.5312 49.4165 26.7067 49.7095 26.733 49.7095C28.9022 49.7095 30.499 47.2495 30.499 42.963C30.499 40.7518 29.6845 37.1243 28.0395 32.1753C27.636 30.9615 28.5395 29.7088 29.8187 29.7088H36.9422C37.307 29.7088 37.67 29.6632 38.0232 29.5732C40.3647 28.9762 41.7787 26.5942 41.1817 24.253L37.6445 10.38C36.543 6.06038 32.167 3.43482 27.8372 4.49602L8.76795 9.16985C7.10972 9.57627 5.83942 10.9102 5.51442 12.5863L4.50317 17.8015Z"
                                              fill="#05668D"
                                            />
                                          </svg>
                                          <span className="answer-rate-down-number">
                                            {r.dislike}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <ul className="review-answer-child"></ul>
                                    {arr.length - 1 === I &&
                                    replies.length !== arr.length ? (
                                      <div
                                        onClick={() => {
                                          getcommentreplies(c.id);
                                        }}
                                        className="review-show-more"
                                      >
                                        show more replies
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </li>
                                );
                                // }
                              })}
                            </ul>
                          )}
                        </li>
                      );
                    }
                  })}
              </ul>
            </div>
          </div>
        </div>
        {/* end article reviews section*/}
      </div>
      <FooterComp className="blog-footer" />
    </>
  );
};

export default ArticleComp;
